import { ENVIRONMENT_VARIABLES, EnvironmentVariables } from '@/types/env.ts'

interface WindowConfig extends Window {
  configs?: {
    [key: string]: string
  }
}

export function isLocalEnv() {
  return getEnv(ENVIRONMENT_VARIABLES.VITE_ENVIRONMENT) === 'local'
}
export function isDevEnv() {
  return getEnv(ENVIRONMENT_VARIABLES.VITE_ENVIRONMENT) === 'dev'
}
export function isLocalOrDevEnv() {
  return (
    getEnv(ENVIRONMENT_VARIABLES.VITE_ENVIRONMENT) === 'local' ||
    getEnv(ENVIRONMENT_VARIABLES.VITE_ENVIRONMENT) === 'dev'
  )
}
export function isIntEnv() {
  return getEnv(ENVIRONMENT_VARIABLES.VITE_ENVIRONMENT) === 'int'
}
export function isProdEnv() {
  return getEnv(ENVIRONMENT_VARIABLES.VITE_ENVIRONMENT) === 'prod'
}

export function getAppWindowTitle() {
  if (isProdEnv()) return 'DeepID | DeepCloud'

  const environment = getEnvironmentLabel()
  return environment
    ? `DeepID | DeepCloud | ${environment}`
    : 'DeepID | DeepCloud'
}

// VITE_ENVIRONMENT is 'dev' for both the sdbx and dev stages, so the hostname
// (ident-sdbx.deepid.swiss vs ident-dev.deepid.swiss) is the only way to tell them apart.
function getEnvironmentLabel() {
  if (isLocalEnv()) return 'local'

  const stage = window.location.hostname.match(/^ident-(sdbx|dev|int)\./)?.[1]
  return stage || getEnv(ENVIRONMENT_VARIABLES.VITE_ENVIRONMENT)
}

export default function getEnv(varName: EnvironmentVariables) {
  return (
    (window as WindowConfig)?.configs?.[varName] || import.meta.env[varName]
  )
}
